// For Velo API Reference documentation visit https://www.wix.com/velo/reference/api-overview
// To learn about widget code visit https://support.wix.com/en/article/wix-blocks-coding-in-blocks
import { products } from 'wix-stores.v2'

async function getProduct(productId) {
    const productsApi = products.getProduct ?
        products :
        // @ts-expect-error
        products.products;
    
    return productsApi.getProduct(productId);
}

$widget.onPropsChanged(async (oldProps, newProps) => {
    const { productId, threshold } = newProps;
    const container = $w('#box1');
    const countdownInfo = $w('#countdownInfo');

    const productIdChanged = productId && productId !== oldProps.productId;
    const thresholdChanged = threshold && threshold !== oldProps.threshold;
    const shouldComponentUpdate = productIdChanged || thresholdChanged;

    if (!shouldComponentUpdate) {
        return;
    }

    let product;
    
    try {
        product = (await getProduct(productId)).product;
    } catch (e) {
        console.error('Stock Counter getProduct', e);
        return;
    }

    const { inStock, quantity } = product.stock;
    const isOutOfStock = !inStock || quantity === 0;
    const isLowStock = quantity > 0 && quantity < threshold;

    container.expand();

    if (isOutOfStock) {
        container.collapse();
    } else if (isLowStock) {
        countdownInfo.text = `Only ${quantity} left in stock`;
    } else {
        countdownInfo.text = 'In stock'
    }
});
